/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_ALL_GEOS, GET_ALL_ENV_TYPES, SET_NO_GEO, SET_SELECTED_GEO, SET_SELECTED_INSTANCE } from "./types";

export const getAllGeoAction = (geos: any, noGeo: boolean) => {
  return {
    type: GET_ALL_GEOS,
    geos,
    noGeo
  };
};

export const setSelectedGeoAction = (selectedGeo: any) => {
  return {
    type: SET_SELECTED_GEO,
    selectedGeo,
  };
};

export const setNoGeoAction = (noGeo: boolean) => {
  return {
    type: SET_NO_GEO,
    noGeo,
  };
};

export const getAllEnvTypesAction = (envTypes: any, noEnvType: boolean) => {
  return {
    type: GET_ALL_ENV_TYPES,
    envTypes,
    noEnvType
  };
}

export const setSelectedIntanceAction = (selectedInstance: any) => {
  return {
    type: SET_SELECTED_INSTANCE,
    selectedInstance,
  };
}